module.exports = __webpack_public_path__ + "static/media/iReForm.13ba31fa.png";